import PropTypes from 'prop-types';

export default PropTypes.shape({
  url: PropTypes.string,
  /**
   * we need node here because this can be mixed content
   * containing text, markup or React components
   */
  name: PropTypes.oneOfType([PropTypes.string, PropTypes.node, PropTypes.element, PropTypes.object]),
  external: PropTypes.bool,
  fetchUrl: PropTypes.string,
});
